import * as React from 'react'
import { Accordion as BSAccordion, Form } from 'react-bootstrap'
import { O, pipe, t } from '@packages/prelude'
import { faStar } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'styled-components'
import { AccordionToggleButton } from '../Buttons'

interface Props {
  id: string
  title: string
  onTextChange: (text: O.Option<string>) => void
  onToggle: () => void
  inputLabel?: string
  description?: string
  selected?: boolean
  optional?: boolean
}

const Accordion = styled(BSAccordion)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  padding: 0.5rem 0.5rem 0.5rem 1.5rem;

  background: var(--primary);
  color: var(--bs-white);
  border-radius: 2rem;

  font-size: 1.5rem;

  .btn {
    box-shadow: none !important;
    background: var(--bs-white) !important;
    color: var(--primary) !important;

    margin: 0 !important;
    padding: 0 !important;
    font-size: 1.25rem;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 2.5rem;
    height: 100%;
  }
`

const Collapse = styled(Accordion.Collapse)`
  padding: 0.5rem 0.5rem 0.5rem 1.5rem;
`

export const View: React.FC<Props> = ({
  title,
  id,
  onTextChange,
  onToggle,
  optional = true,
  inputLabel,
  description,
  selected = false
}) => {
  const onChangeHandler = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      pipe(e?.target?.value, t.NonEmptyString.decode, O.fromEither, onTextChange)
    },
    [onTextChange]
  )

  return (
    <Accordion>
      <Container>
        <AccordionToggleButton.Switch eventKey={id} onToggle={onToggle} selected={selected} />
        {title}
        {!optional && <FontAwesomeIcon icon={faStar} />}
      </Container>
      <Collapse eventKey={id}>
        <Form.Group>
          {t.NonEmptyString.is(inputLabel) && <Form.Label>{inputLabel}</Form.Label>}
          <Form.Control as="textarea" rows={3} onChange={onChangeHandler} />
          {t.NonEmptyString.is(description) && <Form.Text muted>{description}</Form.Text>}
        </Form.Group>
      </Collapse>
    </Accordion>
  )
}

export default Object.assign(View, {})
